import React from 'react';

const Methodology = () => {
    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.title}>The "Confidence-First" Method</h1>
                <p style={styles.subtitle}>Why traditional learning fails and why we succeed.</p>
            </header>

            <div style={styles.section}>
                <h2>1. Psychology Over Grammar</h2>
                <p>Most institutes start with rules. We start with fear removal. Our "Ice-Breaker" sessions are designed to lower the affective filter.</p>
            </div>

            <div style={styles.section}>
                <h2>2. The "One Focus" Rule</h2>
                <p>You cannot learn everything at once. Our AI tracks only ONE metric at a time (e.g., Pause Frequency) until you master it.</p>
            </div>

            <div style={styles.section}>
                <h2>3. Real-World Simulation</h2>
                <p>No textbooks. We use real interview questions, office scenarios, and debate topics.</p>
            </div>
        </div>
    );
};

const styles = {
    container: { maxWidth: '800px', margin: '0 auto', padding: '60px 20px' },
    header: { textAlign: 'center', marginBottom: '60px' },
    title: { fontSize: '36px', color: '#2f3e46' },
    subtitle: { fontSize: '18px', color: '#666' },
    section: { marginBottom: '40px' }
};

export default Methodology;
